import { numberRegexp, phoneFormat, phoneRegExp } from '@constants/regexp';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { ChangeEvent, useContext } from 'react';

import useSendCode from './useSendCode';
import useVerification from './useVerification';
import SignUpContext from '../../../context/SignUpContext';

function useCertification() {
    const {
        useValue, useInputValue, useVerified, useInputAuthCode,
    } = useContext(SignUpContext);
    const isEmail = useIsEmailSignIn();
    const [inputValue, setInputValue] = useInputValue;
    const [certValue, setCertValue] = useValue;
    const [isVerified, setVerified] = useVerified;
    const [code, setCode] = useInputAuthCode;
    const onChangeValue = (e: ChangeEvent<HTMLInputElement>) => {
        setVerified(false);
        setCertValue('');
        if (isEmail) {
            setInputValue(e.target.value);
        } else {
            setInputValue(e.target.value.replace(numberRegexp, '')
                .replace(phoneRegExp, phoneFormat));
        }
    };
    const onChangeCode = (e: ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value.replace(numberRegexp, ''));
    };
    const requestSms = useSendCode({ value: inputValue });
    const requestVerify = useVerification({ code });

    return {
        inputValue,
        onChangeValue,
        code,
        onChangeCode,
        certValue,
        isVerified,
        requestVerify,
        requestSms,
    };
}

export default useCertification;
